// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__2gChi","title":"Logo_title__2SKvJ","title1":"Logo_title1__fWkSi","title2":"Logo_title2__3nOsp","title3":"Logo_title3__1LjMg","subtitle":"Logo_subtitle__3GaqC"};